import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-blue-600 rounded-sm flex items-center justify-center">
                <span className="text-white font-black text-xl font-['Chivo']">875</span>
              </div>
              <span className="font-black text-xl font-['Chivo']">875 Construction Corp</span>
            </div>
            <p className="text-slate-400 leading-relaxed mb-6">
              Trusted construction services in Lagrange, IL. Specializing in windows, doors, 
              kitchens, and bathrooms for over 15 years.
            </p>
            <div className="flex items-center gap-2 text-slate-400">
              <Clock className="w-4 h-4" />
              <span className="text-sm">Mon-Fri: 8AM - 6PM | Sat: 9AM - 3PM</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-6 font-['Chivo']">Our Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-slate-400 hover:text-blue-400 transition-colors">
                  Window Installation
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-blue-400 transition-colors">
                  Door Installation
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-blue-400 transition-colors">
                  Kitchen Remodeling
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-blue-400 transition-colors">
                  Bathroom Renovation
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-blue-400 transition-colors">
                  New Construction
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-6 font-['Chivo']">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-blue-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-slate-400 hover:text-blue-400 transition-colors">
                  Project Gallery
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-slate-400 hover:text-blue-400 transition-colors">
                  Book Appointment
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-blue-400 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-6 font-['Chivo']">Contact Us</h3>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:708-856-1055" 
                  className="flex items-center gap-3 text-slate-400 hover:text-blue-400 transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="w-5 h-5 text-blue-500" />
                  <span>708-856-1055</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:ejquintana875@gmail.com" 
                  className="flex items-center gap-3 text-slate-400 hover:text-blue-400 transition-colors"
                  data-testid="footer-email"
                >
                  <Mail className="w-5 h-5 text-blue-500" />
                  <span>ejquintana875@gmail.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-5 h-5 text-blue-500 mt-0.5" />
                <span>Lagrange, IL</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} 875 Construction Corp. All rights reserved.
          </p>
          <p className="text-slate-500 text-sm">
            Serving Lagrange, Western Springs, Brookfield & surrounding areas
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
